import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Skeleton } from "@/components/ui/skeleton";
import IntegrationBrief from "@/pages/IntegrationBrief";
import { useSites } from "@/lib/queries";
import { useApp } from "@/lib/app";

/** Admin-only: the Live Count Feed integration brief (API key, deliveries, handoff prompt), inside the v2 shell. */
export default function LiveFeed() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { feed } = useApp();
  const sites = useSites();

  useEffect(() => {
    document.title = "Zapin | Live Count Feed";
  }, []);

  if (!sites.data) return <div className="space-y-4" data-testid="live-feed-loading"><Skeleton className="h-24 w-full rounded-xl" /><Skeleton className="h-72 w-full rounded-xl" /></div>;
  return (
    <div data-testid="live-feed-page">
      <IntegrationBrief feed={feed} onFeedChange={(f) => qc.setQueryData(["feed-status"], f)} sites={sites.data.sites || []} onNavigate={() => navigate("/")} />
    </div>
  );
}
